export const title = "Raamatuvahetus"
export const icon = "/assets/images/raamatuvahetus-icon.png"
export const description = "Raamatute vahetamise platvorm"
